import {Types} from './actions.menu.types'

export function toggleMobileMenu() {
  return {
    type: Types.TOGGLE_MOBILE_MENU,
  }
}
